<template>
  <section class="checks-container">
    <div>
      <checks-item
        v-for="checksGroup in checksToDisplay"
        @addChecks="addChecks"
        :item="checksGroup"
        :key="checksGroup.ID"
      />
    </div>
  </section>
</template>

<script>
import ChecksItem from "@/components/checks/checks-item.vue";
import { __ } from "@/plugins/i18n";

export default {
  components: {
    ChecksItem,
  },
  data() {
    return {
      errorMsg: "",
    };
  },

  mounted() {
    // this.loadChecks();
  },
  methods: {
    addChecks(item) {
      this.$router.push(`/checks/checksfill/${item.ID}`);
    },
    // async loadChecks() {
    //   try {
    //     if (
    //       this.$store.getters.isInitiallyCommitted &&
    //       this.checksToDisplay?.length
    //     ) {
    //       return;
    //     }
    //     await this.$store.dispatch("loadChecks");
    //   } catch (error) {
    //     this.$toast.add({
    //       severity: "error",
    //       summary: __("Error"),
    //       detail: __("Something went wrong"),
    //       life: 10000,
    //       closable: true,
    //     });
    //   }
    // },
  },
  computed: {
    checksToDisplay() {
      return this.$store.getters.checks;
    },
  },
};
</script>
<style scoped>
.checks-page-container {
  padding: 20px;
}

.checks-table {
  width: 100%;
  margin-bottom: 20px;
}

.checks-table .p-vue-column {
  text-align: left;
}

.date-container {
  display: flex;
  align-items: center;
}

.date-container span {
  margin-right: 10px;
}

.checks-actions .p-button {
  margin-right: 10px;
}

.middle .amount {
  width: 22%;
}
.middle .numbers-of-payments {
  width: 39%;
}
.middle .first-check-day {
  width: 39%;
}
.middle .lable {
  color: #484f61;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.middle .value {
  color: #373c49;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.action {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  color: var(--Green-buildup, #469609);
}
.action .lable {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 5px;
}
.action .icon {
  margin: 5px;
}
</style>
